/**
 * Created by Swaniti-Initiative on 8/23/17.
 */
export class RestApiConnection {

  Host:string;
  port:number;

}



// WEBPACK FOOTER //
// ./src/app/classes/RestApiConnection.class.ts